import axios from 'axios'
import { ref, computed, watch } from 'vue'

const inputValid = {
    tag: (val) => !!(val === '' || /^[&0-9a-zA-Z,;+\-_/ ]+$/.test(val))
}

const URLS = {
    user: '/profile/v1/settings/user/',
    info: '/profile/v1/info/venue/'
}

const persistKeywords = ref([])
const keywordInput = ref('')

export default function (suggestedTags, prevKeywords = null) {
    const compErrMsg = ref('')
    const keywords = ref([])
    const suggestedKeywords = ref(suggestedTags)
    const renderSuggestedKeywords = computed(() => suggestedKeywords.value.filter((k) => !k.selected))

    ;(() => {
        if (prevKeywords) keywords.value = prevKeywords
    })()

    watch(
        keywords,
        (keywords) => {
            persistKeywords.value = keywords
        },
        { deep: true }
    )

    function handleAddTag(error) {
        if (error) return

        keywordInput.value.split(/[,;]/).forEach((tag) => {
            tag = tag.trim()

            if (!tag) return

            if (!keywords.value.includes(tag)) {
                let suggestedKeyword = suggestedKeywords.value?.find((k) => k.name.toLowerCase() === tag.toLowerCase())

                if (suggestedKeyword && !keywords.value.includes(suggestedKeyword.name)) {
                    suggestedKeyword.selected = true
                    keywords.value.push(suggestedKeyword.name)
                } else if (!suggestedKeyword) {
                    keywords.value.push(tag)
                }
            }
        })
        keywordInput.value = ''
    }

    function handleDeleteTag(indx) {
        for (let i = 0; i < suggestedKeywords.value.length; i++) {
            if (suggestedKeywords.value[i].name === keywords.value[indx]) {
                suggestedKeywords.value[i].selected = false
            }
        }

        keywords.value.splice(indx, 1)
    }

    function handleSelectTag(tag) {
        if (tag.selected) {
            keywords.value.splice(keywords.value.indexOf(tag.name), 1)

            tag.selected = false
        } else {
            keywords.value.push(tag.name)
            tag.selected = true
        }
    }

    function populateKeywords(data) {
        if (!data) return ''

        let dataKeywords = data.split(',')
        for (let i = 0; i < dataKeywords.length; i++) {
            let keyword = dataKeywords[i]

            for (let j = 0; j < suggestedKeywords.value.length; j++) {
                let key = suggestedKeywords.value[j]

                if (key.name === keyword && !keywords.value.includes(keyword)) {
                    key.selected = true
                    keywords.value.push(keyword)
                    break
                }
            }

            if (!keywords.value.includes(keyword)) {
                keywords.value.push(keyword)
            }
        }
    }

    function clearKeywords() {
        suggestedKeywords.value.forEach((k) => (k.selected = false))
        keywords.value.splice(0)
    }

    function validate() {
        for (let i = 0; i < keywords.value.length; i++) {
            if (!inputValid.tag(keywords.value[i])) {
                compErrMsg.value = '[422] : Please enter keywords without special characters.'
                return false
            }
        }

        compErrMsg.value = ''
        return true
    }

    function validateKeywordInput(_input) {
        inputValid.tag(keywordInput.value) ? (_input.error = false) : (_input.error = true)
    }

    function formatTags(arr) {
        if (!arr.length) return ''
        return arr.map((val) => val.trim()).join(',')
    }

    async function updateInfo(data) {
        try {
            let userResp = await axios.get(URLS.user)
            let userId = userResp.data.data[0].id

            let infoResp = await axios.post(URLS.info + userId, {
                _method: 'PUT',
                ...data
            })
            return infoResp
        } catch (err) {
            compErrMsg.value = `[${err.response?.status}] : ${err.response?.data?.message}`
            throw err
        }
    }

    return {
        persistKeywords,
        keywordInput,
        suggestedKeywords,
        renderSuggestedKeywords,
        compErrMsg,
        keywords,
        handleAddTag,
        handleSelectTag,
        handleDeleteTag,
        populateKeywords,
        clearKeywords,
        validate,
        validateKeywordInput,
        formatTags,
        updateInfo
    }
}
